import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ListingCard from '../components/ListingCard';
import BrowseForSale from '../components/BrowseForSale';
import { useApi } from '../services/api';

export default function Browse() {
  const [tab, setTab] = useState('stays');
  const [filters, setFilters] = useState({ max_price: '', check_in_after: '', check_in_before: '' });
  const [applied, setApplied] = useState({});

  const query = Object.entries(applied)
    .filter(([, v]) => v)
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&');

  const { data, loading, error } = useApi(`/listings${query ? `?${query}` : ''}`);
  const listings = data?.listings || [];

  function applyFilters(e) {
    e.preventDefault();
    // Convert display dollar amount to cents for the API
    setApplied({
      ...filters,
      max_price: filters.max_price ? Math.round(parseFloat(filters.max_price) * 100) : '',
    });
  }

  function clearFilters() {
    setFilters({ max_price: '', check_in_after: '', check_in_before: '' });
    setApplied({});
  }

  return (
    <div className="page">
      <Navbar />

      <div className="container" style={{ padding: '2rem 1rem' }}>
        <h1 style={{ fontSize: 'var(--text-xl)', fontWeight: 700, marginBottom: '0.5rem' }}>
          Browse Listings
        </h1>
        <p style={{ color: 'var(--ink-muted)', marginBottom: '1.5rem' }}>
          {tab === 'stays'
            ? 'Prices automatically fall as check-in approaches — the later you buy, the better the deal.'
            : 'Timeshare weeks for sale directly from owners — no agent fees, no middleman.'}
        </p>

        <div className="dashboard-tabs">
          <button className={`tab-btn ${tab === 'stays' ? 'active' : ''}`} onClick={() => setTab('stays')}>Available Stays</button>
          <button className={`tab-btn ${tab === 'forsale' ? 'active' : ''}`} onClick={() => setTab('forsale')}>For Sale</button>
        </div>

        {tab === 'stays' && (
          <>
            {/* Filter bar */}
            <form onSubmit={applyFilters} style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', marginBottom: '1.75rem', alignItems: 'flex-end' }}>
              <div className="form-group" style={{ marginBottom: 0, minWidth: 160 }}>
                <label>Max price ($)</label>
                <input
                  type="number" min="0" placeholder="e.g. 1500"
                  value={filters.max_price}
                  onChange={e => setFilters(f => ({ ...f, max_price: e.target.value }))}
                />
              </div>
              <div className="form-group" style={{ marginBottom: 0, minWidth: 160 }}>
                <label>Check-in after</label>
                <input
                  type="date"
                  value={filters.check_in_after}
                  onChange={e => setFilters(f => ({ ...f, check_in_after: e.target.value }))}
                />
              </div>
              <div className="form-group" style={{ marginBottom: 0, minWidth: 160 }}>
                <label>Check-in before</label>
                <input
                  type="date"
                  value={filters.check_in_before}
                  onChange={e => setFilters(f => ({ ...f, check_in_before: e.target.value }))}
                />
              </div>
              <button type="submit" className="btn btn-primary btn-sm">Apply</button>
              {Object.values(applied).some(Boolean) && (
                <button type="button" className="btn btn-outline btn-sm" onClick={clearFilters}>Clear</button>
              )}
            </form>

            {loading && <p style={{ color: 'var(--ink-muted)' }}>Loading listings…</p>}
            {error && <div className="alert alert-error">Failed to load listings. Please refresh.</div>}

            {!loading && !error && (
              listings.length > 0 ? (
                <>
                  <p style={{ color: 'var(--ink-muted)', fontSize: 'var(--text-base)', marginBottom: '1rem' }}>
                    {listings.length} listing{listings.length !== 1 ? 's' : ''} available
                  </p>
                  <div className="listing-grid">
                    {listings.map(l => <ListingCard key={l.id} listing={l} />)}
                  </div>
                </>
              ) : (
                <div style={{ textAlign: 'center', padding: '3rem 0', color: 'var(--ink-muted)' }}>
                  <p style={{ fontSize: 'var(--text-lg)' }}>No listings match your filters.</p>
                  {Object.values(applied).some(Boolean) && (
                    <button onClick={clearFilters} className="btn btn-outline btn-sm" style={{ marginTop: '1rem' }}>
                      Clear filters
                    </button>
                  )}
                </div>
              )
            )}
          </>
        )}

        {tab === 'forsale' && <BrowseForSale />}
      </div>

      <Footer />
    </div>
  );
}
